exports.disableCorePrefetching = () => true